var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.201 17.201"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.601h15.787M7.894.707l7.894 7.894-7.894 7.893"
  }))));
};
export default SvgArrow;